import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

/**
 * DataCell: Now accepts a 'label' prop to identify the column.
 */
export const DataCell = ({ value, label, onClick, limit = 150 }) => {
  const isLong = value && value.toString().length > 25;

  return (
    <td 
      className={isLong ? "clickable-cell" : ""} 
      /* We pass an object to the onClick handler */
      onClick={isLong ? () => onClick({ text: value, title: label }) : null}
    >
      {isLong ? (
        <div className="truncate-limit" style={{ maxWidth: `${limit}px` }}>
          {value}
        </div>
      ) : (
        value || "-" 
      )}
    </td>
  );
};

/**
 * The eye icon next to a masked value. Only rendered for roles that may unmask (SYSTEM_ADMIN / ADMIN); each click that
 * shows a value is one call to the service, which records it in the PII access log. `shown` flips it to the crossed-out
 * eye that hides the value again.
 */
export const EyeButton = ({ shown = false, busy = false, label, onClick }) => (
  <button
    type="button"
    className="pii-eye-button"
    onClick={onClick}
    disabled={busy}
    aria-label={shown ? `Hide ${label}` : `Show ${label}`}
    title={shown ? `Hide ${label}` : `Show ${label} (this view is recorded)`}
  >
    <FontAwesomeIcon icon={shown ? faEyeSlash : faEye} />
  </button>
);

export const CommonModal = ({ isOpen, onClose, title, children, copyValue }) => {
  if (!isOpen) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(copyValue);
    alert("Copied to clipboard!");
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          {/* Now displays the dynamic column name */}
          <h3>{title}</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
       <div className="modal-footer">
        {copyValue && (
            <button onClick={handleCopy}>
            Copy Content
            </button>
        )}
        <button className="btn-outline" onClick={onClose}>
            Close
        </button>
    </div>
      </div>
    </div>
  );
};